import { Button } from "components/Button/Button";
import { Form } from "components/Form/components/Form/Form";
import { FormComponentProps } from "components/Form/components/FormComponentProps";
import { RadioGroup } from "components/Form/components/RadioGroup/RadioGroup";
import { TextareaFormComponent } from "components/Form/components/Textarea/TextareaFormComponent";
import style from "../CommitAction.module.scss";

interface CommitGeneratorFieldProps extends FormComponentProps {
    generatedMessage: string;
    isDisabled: boolean;
    disableButtonAndForm: () => void;
    isMessageAutoGenerated: boolean;
    setMessageAutoGenerated: (value) => void;
}

export const CommitGeneratorField = ({
    generatedMessage,
    isDisabled,
    disableButtonAndForm,
    input,
    fieldAttr,
    meta,
    fieldProps,
    isMessageAutoGenerated,
    setMessageAutoGenerated,
}: CommitGeneratorFieldProps) => {
    return (
        <div className={style.commitField}>
            <Form.Row>
                <RadioGroup
                    options={[
                        { value: "true", label: "Automatically generate commit message" },
                        {
                            value: "false",
                            label: "Override commit message",
                        },
                    ]}
                    input={{
                        value: isMessageAutoGenerated.toString(),
                        onChange: (e) => setMessageAutoGenerated(e.target.value === "true"),
                    }}
                    identifier="selectAll"
                />
            </Form.Row>
            <Form.Row>
                <div className={style.commitButton}>
                    <Button
                        disabled={isMessageAutoGenerated || isDisabled}
                        variation="primary"
                        label={"Generate commit message"}
                        onClick={() => {
                            input.onChange(generatedMessage);
                            disableButtonAndForm();
                        }}
                    />
                </div>
            </Form.Row>
            <TextareaFormComponent
                input={input}
                fieldAttr={{ ...fieldAttr, disabled: isMessageAutoGenerated }}
                fieldProps={fieldProps}
                meta={meta}
            />
        </div>
    );
};
